import { useEffect, useState, type DragEvent } from 'react';
import { DRAG_TYPE, type MoveItem } from './folders.js';

// Drag and drop for forms and folders (native HTML5 — desktop; "Move to…"
// covers keyboard and touch).

/** Props that make an element draggable as `item`. */
export function dragSource(
  item: MoveItem,
  onStart: (item: MoveItem) => void,
  onEnd: () => void,
) {
  return {
    draggable: true,
    onDragStart: (e: DragEvent) => {
      e.dataTransfer.setData(DRAG_TYPE, item.id);
      e.dataTransfer.effectAllowed = 'move';
      onStart(item);
    },
    onDragEnd: onEnd,
  };
}

/** Drop-target wiring: highlights while a valid item hovers, calls onDrop. */
export function useDropTarget(enabled: boolean, onDrop: () => void) {
  const [over, setOver] = useState(false);
  useEffect(() => {
    if (!enabled) setOver(false);
  }, [enabled]);
  const props = {
    onDragOver: (e: DragEvent) => {
      if (!enabled || !e.dataTransfer.types.includes(DRAG_TYPE)) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      if (!over) setOver(true);
    },
    onDragLeave: (e: DragEvent) => {
      if (!e.currentTarget.contains(e.relatedTarget as Node | null)) setOver(false);
    },
    onDrop: (e: DragEvent) => {
      if (!enabled) return;
      e.preventDefault();
      setOver(false);
      onDrop();
    },
  };
  return { over, props };
}
